import { faClipboardQuestion, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useState } from "react";
import { Clipboard2 } from "react-bootstrap-icons";
import { Link, NavLink, useParams } from "react-router-dom";
import Authentication from "../../../../libs/api/services/Authentication";
import Dashboards from "../../../../libs/api/services/Dashboards";
import { ClaimsFilter } from "../../../../libs/authentication/ClaimsFilter";
import CommonFunctionsContext from "../../../common/CommonFunctionsProvider";
import DashboardWorkFlowCard from "../../dashboards/Widgets/DashboardWorkFlowCard";
import PatientContext from "./PatientProvider";
import WorkFlowPatientHistory from "../history/WorkFlowPatientHistory";

export default function PatientProfileDashboard({ type }) {
  const { setSectionInfo } = useContext(CommonFunctionsContext);
  const { activePatient } = useContext(PatientContext);
  const [pid, setPid] = useState();
  const { id } = useParams();
  const [wokFlowCards, setWokFlowCards] = useState([]);

  useEffect(() => {
    if (id) setPid(id);
    else if (activePatient) setPid(activePatient.id);
  }, [id]);

  const _loadWorkFlowCards = async () => {
    const roles = Authentication.getFacilityRoles();
    var cards = [];
    if (roles.includes("Admin")) {
      for (const c of await Dashboards.GetDashboardWorkflowCards(
        "ADMIN_PATIENT_DASHBOARD"
      ))
        cards.push(<DashboardWorkFlowCard {...c} patient={pid} />);
    }
    if (roles.includes("Clinician")) {
      for (const c of await Dashboards.GetDashboardWorkflowCards(
        "CLINICIAN_PATIENT_DASHBOARD"
      ))
        cards.push(<DashboardWorkFlowCard {...c} patient={pid} />);
    }
    /**
     * ADMIN_PATIENT_DASHBOARD
     * CLINICIAN_PATIENT_DASHBOARD
     * ADMIN_DASHBOARD
     * CLINICIAN_DASHBOARD
     * PATIENT_DASHBOARD
     */

    setWokFlowCards(cards);
  };
  useEffect(() => {
    if (pid) {
      setSectionInfo(`Managing patient`);
      _loadWorkFlowCards();
    }
    return () => {
      setSectionInfo(undefined);
    };
  }, [pid]);

  useEffect(() => {
    if (activePatient)
      setSectionInfo(
        `Managing patient ${activePatient.userProfile.firstName} ${
          activePatient.userProfile.lastName
        } at ${Authentication.getFacilityName()}`
      );
    else
      setSectionInfo(`Managing patient at ${Authentication.getFacilityName()}`);
    return () => {
      setSectionInfo(undefined);
    };
  }, [activePatient]);
  return (
    <div className="p-3 flex-grow-1" style={{ overflow: "auto" }}>
      {/* <h1 className='ms-2 text-center'>Quick Links</h1> */}
      <div className="d-flex flex-row align-items-evenly justify-content-between">
        <ClaimsFilter
          resources={[
            { resource: "PatientProfile", type: "View" },
            { resource: "PatientProfile", type: "Edit" },
            { resource: "PatientProfile", type: "Inherit" },
          ]}
          claim={[]}
        >
          <NavLink
            tag={Link}
            key={"ust"}
            to={"/Dashboard/Patient/" + pid + "/"}
            className="flex-grow-1 m-2 text-center bg-secondary-container rounded p-2"
            style={{ cursor: "pointer" }}
          >
            <div>
              <FontAwesomeIcon className="m-3" size="3x" icon={faUser} />
            </div>
            <b>Patient Profile Information</b>
            <p className="p-2">Manage patient profile information</p>
          </NavLink>
        </ClaimsFilter>
        <ClaimsFilter
          resources={[
            { resource: "Questionnaires", type: "View" },
            { resource: "Questionnaires", type: "Edit" },
            { resource: "Questionnaires", type: "Inherit" },
          ]}
          claim={[]}
        >
          <NavLink
            tag={Link}
            key={"ust"}
            to={"/Dashboard/Patient/" + pid + "/Questionnaires"}
            className="flex-grow-1 m-2 text-center bg-secondary-container rounded  p-2"
            style={{ cursor: "pointer" }}
          >
            <div>
              <FontAwesomeIcon
                className="m-3"
                size="3x"
                icon={faClipboardQuestion}
              />
            </div>
            <b>Patient Questionnaires</b>
            <p className="p-2">View / Assign Questionnaires to patient</p>
          </NavLink>
        </ClaimsFilter>
        <ClaimsFilter
          resources={[
            { resource: "Forms", type: "View" },
            { resource: "Forms", type: "Edit" },
            { resource: "Forms", type: "Inherit" },
          ]}
          claim={[]}
        >
          <NavLink
            tag={Link}
            key={"ust"}
            to={"/Dashboard/Patient/" + pid + "/Forms"}
            className="flex-grow-1  m-2 text-center bg-secondary-container rounded p-2"
            style={{ cursor: "pointer" }}
          >
            <div>
              <Clipboard2 className="m-3" size="50px" />
            </div>
            <b>Patient Forms</b>
            <p className="p-2">View / Complete patient forms</p>
          </NavLink>
        </ClaimsFilter>
      </div>
      {/* <div className="row g-2">{wokFlowCards}</div> */}
      <Tabs wokFlowCards={wokFlowCards} />
    </div>
  );
}

const Tabs = ({ wokFlowCards }) => {
  const [tab, setTab] = useState("History");
  return (
    <div className="mt-3">
      <ul className="nav nav-tabs" role="tablist">
        <li className="nav-item" role="presentation">
          <button
            type="button"
            className={`nav-link ${tab === "History" ? "active" : ""}`}
            onClick={() => setTab("History")}
            role="tab"
            aria-selected={tab === "History"}
          >
            Patient History
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            type="button"
            className={`nav-link ${tab === "Quick Links" ? "active" : ""}`}
            onClick={() => setTab("Quick Links")}
            role="tab"
            aria-selected={tab === "Quick Links"}
          >
            Quick Links
          </button>
        </li>
      </ul>

      <div style={{maxWidth:'100%'}} className="tab-content p-3 border border-top-0 bg-white rounded-bottom row mt-0 g-2">
        {tab === "History" ? (
          <div className="tab-pane active">
				<WorkFlowPatientHistory />
			
		</div>
        ) : (wokFlowCards)}
      </div>
    </div>
  );
};
